import React from 'react';
import $ from 'jquery';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'connected-react-router';
import forwardArrowButton from '../../svg/forward-arrow-button.svg';

import BillingWindow from '../Wrappers/BillingWindow';
import SubscriptionAgreement from './SubscriptionAgreement';
import * as billingActions from '../../redux/billing';
import Checkbox from '../Checkbox';
import { SmallTitle } from './Common';

const AgreementIntro = styled.div`
  font-family: BrandonGrotesque-Regular;
  font-size: 14px;
  letter-spacing: 1px;
  color: #555555;
  margin-left: 20px;
`;

const AgreementLink = styled.span`
  font-family: BrandonGrotesque-Bold;
  text-decoration: underline;
  cursor: pointer;
`;

const EmailField = styled.input`
  width: 100%;
  margin: 0;
  height: auto;
  padding: 0;
  padding-left: 15px;
  border: none;
  background-color: #fafafa;
`;

interface Props {
  billing: any;
  customer: any;
  openMethods: any;
  desktop: boolean;
}
interface State {
  email: string;
  agreed: boolean;
  sent: boolean;
}
class BillingIntro extends React.Component<Props, State> {
  private height = window.innerHeight;
  state: State = {
    email: '',
    agreed: false,
    sent: false,
  };

  changeEmail(event: any) {
    this.setState({ email: event.target.value });
  }

  flipAgree() {
    this.setState({ agreed: !this.state.agreed });
  }

  showAgreement() {
    return $('#subscriptionAgreement').appendTo('body').modal('show') as any;
  }

  save() {
    this.setState({ sent: true });
    this.props.billing.createCustomer(this.state.email, '/billing/methods');
  }

  render() {
    const ready = this.state.agreed && this.state.email;

    if (this.props.customer.id !== null && this.props.customer.id !== undefined) {
      this.props.openMethods();
      return null;
    }

    if (this.props.customer.id === undefined) {
      this.props.billing.loadCustomer();

      return (
        <div className="offer-loader" style={{ height: '500px', paddingTop: '240px' }}>
          Loading...
        </div>
      );
    }

    return (
      <BillingWindow desktop={this.props.desktop} page="intro">
        <br />
        <SmallTitle>BILLING EMAIL</SmallTitle>
        <div className="paymentItem method-row">
          <div className="row cardBorder">
            <div className="col-2 paymentIcon" style={{ backgroundColor: '#eeeeee' }}>
              <img src="/img/envelope.png" alt="Add" />
            </div>
            <div className="col paymentItemName">
              <EmailField type="email" onChange={(e) => this.changeEmail(e)} />
            </div>
          </div>
        </div>
        <p className="billing-small-blue">
          This email will receive all Neon Coat plan communication.
        </p>
        <div className="row justify-content-center" style={{ margin: 'auto', marginTop: '40px' }}>
          <div>
            <Checkbox status={this.state.agreed} flip={() => this.flipAgree()} />
          </div>
          <AgreementIntro>
            I acknowledge that I have read and <br /> agree to the{' '}
            <AgreementLink onClick={() => this.showAgreement()}>
              Neon Coat <br /> Services Agreement.
            </AgreementLink>
          </AgreementIntro>
        </div>
        <div
          className={this.props.desktop ? 'selectPlanButtonDesktop' : 'selectPlanButton'}
          style={{ opacity: ready ? '1' : '0.4', top: this.height - 58 + 'px' } as any}
          onClick={() => ready && this.save()}
        >
          {this.state.sent
            ? 'CREATING ACCOUNT...'
            : <div>SAVE + CONTINUE <img alt="" src={forwardArrowButton} /></div>
          }
        </div>
        <SubscriptionAgreement />
      </BillingWindow>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    customer: state.billing.customer,
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    billing: bindActionCreators(billingActions, dispatch),
    openMethods: () => dispatch(push('/billing/methods')),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BillingIntro);
